import { cn } from '@quadralize/utils'
import * as React from 'react'

export const Separator = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    orientation?: 'horizontal' | 'vertical'
    decorative?: boolean
  }
>(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
  <div
    ref={ref}
    {...(!decorative ? { role: 'separator', 'aria-orientation': orientation } : { role: 'none' })}
    className={cn(
      'shrink-0 bg-border-default',
      orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
      className,
    )}
    {...props}
  />
))

Separator.displayName = 'Separator'
